<template>
  <div>
    <component :is="pageView" @change-page="changePage" v-bind="$attrs" />
  </div>
</template>

<script setup>
import home from './home';
import khbm from './khbm';
import spbm from './spbm';

const pageView = shallowRef(home);

function changePage(page) {
  switch (page) {
    case 'maintence_home':
      pageView.value = home;
      break;
    case 'maintence_khbm':
      pageView.value = khbm;
      break;
    case 'maintence_spbm':
      pageView.value = spbm;
      break;
  }
}
</script>

<style lang="scss" scoped></style>
